
import update from 'immutability-helper';
import { connect } from 'react-redux';
import debounceHandler from '@hocs/debounce-handler';
import { compose, withProps, withState, withHandlers, lifecycle } from 'recompose';
import { withReadyLoader } from 'op/components/loader'

import { withOnlineStatus } from 'op/components/offline';
import { withTypes, withExecutionLevels } from 'op/components/lut';
import { withReportFetch, withReportLoading } from '../../report/report.helper';

export const TAGS_PAGE_SIZE = 10;

export const withPersonReports = compose(
	connect(({ reports, person }, { match }) => ({
		reports: (reports.loaded || []).filter(report => report.person_id.toString() == match.params.person_id),
		person: person.loaded.find(p => p.id.toString() == match.params.person_id),
	})),
	withProps(({ person }) => ({ ready: !!person })),
	withReadyLoader,
	withState('search', 'setSearch', ''),
	withState('loading', 'setLoading', false),
	withState('pageIndex', 'setPageIndex', 0),
	withState('shouldFetchMore', 'setShouldFetchMore', false),
	debounceHandler('setSearch', 1000),
	withReportFetch,
	withReportLoading,
	withTypes,
	withOnlineStatus,
	withHandlers({
		fetchPersonReports: ({ reports, person, fetchReports, addLoadedReports, setLoading, pageIndex, setPageIndex, setShouldFetchMore }) => async () => {
			setLoading(reports.length === 0 ? 'full' : 'partial');

			const distinct = [];
			const fetchedReports = await fetchReports(person, TAGS_PAGE_SIZE, pageIndex * TAGS_PAGE_SIZE);

			addLoadedReports(fetchedReports
				.filter(report => !distinct.includes(report.id) && (distinct.push(report.id) || true))
				.map(report => update(report, { partial: { $set: true } })));

			setShouldFetchMore(fetchedReports.length >= TAGS_PAGE_SIZE);
			setPageIndex(pageIndex + 1);
			setLoading(false);
		}
	}),
	lifecycle({
		async componentDidMount() {
			const { online, fetchPersonReports, fetchTypes } = this.props;

			if (online) {
				await fetchTypes();
				await fetchPersonReports();
			}
		}
	}),
);
